export default __webpack_public_path__ + "static/media/truck.2395b0ca.svg";